import { z } from "zod";

export const conversationDecisionSchema = z
  .object({
    order: z.number().int().positive(),
    decision: z.string().trim().min(1).max(240),
  })
  .strict();

/**
 * Transcrição dos anexos já enviados. Os arquivos não são reenviados a cada
 * pergunta; perguntas seguintes consultam estes dados transcritos.
 */
export const MAX_REMEMBERED_ATTACHMENTS = 10;
export const conversationAttachmentSchema = z
  .object({
    name: z.string().trim().min(1).max(240),
    mediaType: z.string().max(60),
    addedAt: z.string().max(40),
    transcript: z.string().trim().min(1).max(6000),
  })
  .strict();
export type ConversationAttachment = z.infer<typeof conversationAttachmentSchema>;

export const conversationMemorySchema = z
  .object({
    summary: z.string().trim().max(2500).default(""),
    relevantPoints: z.array(z.string().trim().min(1).max(240)).max(16).default([]),
    decisions: z.array(conversationDecisionSchema).max(24).default([]),
    pendingItems: z.array(z.string().trim().min(1).max(240)).max(10).default([]),
    attachments: z.array(conversationAttachmentSchema).max(MAX_REMEMBERED_ATTACHMENTS).default([]),
  })
  .strict();

export type ConversationMemory = z.infer<typeof conversationMemorySchema>;

export const EMPTY_CONVERSATION_MEMORY: ConversationMemory = Object.freeze({
  summary: "",
  relevantPoints: [],
  decisions: [],
  pendingItems: [],
  attachments: [],
});
